import { ScoreEntry } from '@/types/cricket';

// Type for grouped balls by over
export interface GroupedBalls {
  [key: string]: ScoreEntry[];
}

// Type for ball display information
export interface BallDisplayInfo {
  color: string;
  display: string;
  isExtraBall: boolean;
  isFreeHit: boolean;
}

// Type for score components
export interface ScoreComponents {
  regularRuns: number;
  overthrows: number;
  extras: number;
  bonusBoundary: number;
  total: number;
}

// Type guards
export const isWicketBall = (ball: ScoreEntry): boolean => {
  return !!ball.wicket;
};

export const isExtraBall = (ball: ScoreEntry): boolean => {
  return !!ball.extraType;
};

export const isBoundaryBall = (ball: ScoreEntry): boolean => {
  return ball.fours === 1 || 
         ball.sixes === 1 || 
         ball.bonus_boundary === 4 || 
         ball.bonus_boundary === 6;
};

export const isOverthrowBall = (ball: ScoreEntry): boolean => {
  return (ball.overthrows || 0) > 0;
};

export const isRegularRunBall = (ball: ScoreEntry): boolean => {
  return (ball.runs || 0) > 0 && 
         !isWicketBall(ball) && 
         !isExtraBall(ball) && 
         !isBoundaryBall(ball) && 
         !isOverthrowBall(ball);
};

export const isDotBall = (ball: ScoreEntry): boolean => {
  return !isWicketBall(ball) && 
         !isExtraBall(ball) && 
         !isBoundaryBall(ball) && 
         !isOverthrowBall(ball) && 
         !isRegularRunBall(ball);
};

// Helper function to get score components
export const getScoreComponents = (ball: ScoreEntry): ScoreComponents => {
  return {
    regularRuns: ball.runs || 0,
    overthrows: ball.overthrows || 0,
    extras: ball.extras || 0,
    bonusBoundary: ball.bonus_boundary || 0,
    total: (ball.runs || 0) + 
           (ball.overthrows || 0) + 
           (ball.extras || 0) + 
           (ball.bonus_boundary || 0)
  };
}; 